module.exports = __webpack_public_path__ + "media/components/tide-table/static/moon-full-moon-2e806965701108ff566fc0d971731f87.svg";